import { Controller } from "@hotwired/stimulus"

// Placeholder Stimulus controller co-located with the WelcomePanel ViewComponent.
// Establishes the convention: each ViewComponent that needs JS gets its own
// sidecar Stimulus controller in the component's directory.
export default class extends Controller {
  connect() {
    this.element.dataset.welcomePanelConnected = "true"
  }
}
